export const LANGUAGES_DETAILS = {
  ar: { nativeName: "العربية", code: "EG" },
  en: { nativeName: "English", code: "US" },
  fr: { nativeName: "French", code: "FR" },
};
